import { Breadcrumb } from "../../components";

export default function Dashboard() {
  return (
    <div>
      <Breadcrumb />
    </div>
  );
}
